import api from "@/lib/api";

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload/image", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { id, url }
}

export const IMAGE_ACCEPT = "image/png,image/jpeg,image/webp,image/gif";
